export default {"src":"/_next/static/media/topbarmessage.14bb56ef.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};